import { IComodosAssistencia } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/Comodos/ComodosAssistencia";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarComodosService() {
    return Service(
        Axios.get<Array<IComodosAssistencia>>(
            `/assistenciatecnica/comodosassistenciatec/listarcomodos`
        )
    );
}
